export default function ComparisonSection() {
  const data = [
    { feature: "Łatwość obsługi", usfans: "9.8", excel: "8.2", sheets: "8.5" },
    { feature: "Automatyzacja", usfans: "9.7", excel: "7.4", sheets: "8.1" },
    { feature: "Bezpieczeństwo", usfans: "9.5", excel: "8.6", sheets: "8.8" },
    { feature: "Współpraca", usfans: "9.4", excel: "7.1", sheets: "9.3" },
    { feature: "Wydajność", usfans: "9.6", excel: "8.4", sheets: "8.7" },
    { feature: "Cena / Wartość", usfans: "9.3", excel: "7.8", sheets: "9.0" },
  ];

  const tableSchema = {
    "@context": "https://schema.org",
    "@type": "Table",
    "about": "Porównanie funkcji USFansSpreadsheet, Microsoft Excel i Google Sheets",
    "mainEntity": {
      "@type": "ItemList",
      "itemListElement": data.map((row, idx) => ({
        "@type": "ListItem",
        "position": idx + 1,
        "item": {
          "@type": "Thing",
          "name": row.feature,
          "description": `USFansSpreadsheet: ${row.usfans}, Excel: ${row.excel}, Google Sheets: ${row.sheets}`,
        },
      })),
    },
  };

  return (
    <section className="relative w-full bg-background-50 py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-4xl mx-auto">
        <h2 className="font-heading text-2xl sm:text-3xl md:text-4xl font-semibold text-foreground-950 text-center mb-3">
          USFansSpreadsheet – porównanie funkcji
        </h2>
        <p className="text-sm md:text-base text-foreground-500 text-center mb-10 md:mb-14 max-w-xl mx-auto">
          Zobacz, jak nasze rozwiązanie wypada na tle konkurencji w kluczowych obszarach.
        </p>

        <div className="overflow-x-auto rounded-2xl border border-background-200">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="border-b border-background-200">
                <th className="py-4 px-5 md:px-6 text-xs md:text-sm font-medium text-foreground-500">Funkcja</th>
                <th className="py-4 px-5 md:px-6 text-xs md:text-sm font-semibold text-primary-600">
                  <span className="flex items-center gap-2">
                    <span className="w-2 h-2 rounded-full bg-primary-500"></span>
                    USFansSpreadsheet
                  </span>
                </th>
                <th className="py-4 px-5 md:px-6 text-xs md:text-sm font-medium text-foreground-500">
                  <span className="flex items-center gap-2">
                    <span className="w-2 h-2 rounded-full bg-foreground-300"></span>
                    Excel
                  </span>
                </th>
                <th className="py-4 px-5 md:px-6 text-xs md:text-sm font-medium text-foreground-500">
                  <span className="flex items-center gap-2">
                    <span className="w-2 h-2 rounded-full bg-accent-400"></span>
                    Google Sheets
                  </span>
                </th>
              </tr>
            </thead>
            <tbody>
              {data.map((row, idx) => (
                <tr key={idx} className="border-b border-background-100 last:border-b-0 hover:bg-background-50 transition-colors">
                  <td className="py-3.5 px-5 md:px-6 text-sm text-foreground-700 font-medium">{row.feature}</td>
                  <td className="py-3.5 px-5 md:px-6">
                    <div className="flex items-center gap-3">
                      <div className="flex-1 h-1.5 bg-background-200 rounded-full overflow-hidden max-w-[120px]">
                        <div
                          className="h-full bg-primary-500 rounded-full transition-all"
                          style={{ width: `${parseFloat(row.usfans) * 10}%` }}
                        ></div>
                      </div>
                      <span className="text-sm font-semibold text-primary-600 w-8">{row.usfans}</span>
                    </div>
                  </td>
                  <td className="py-3.5 px-5 md:px-6">
                    <div className="flex items-center gap-3">
                      <div className="flex-1 h-1.5 bg-background-200 rounded-full overflow-hidden max-w-[120px]">
                        <div
                          className="h-full bg-foreground-300 rounded-full"
                          style={{ width: `${parseFloat(row.excel) * 10}%` }}
                        ></div>
                      </div>
                      <span className="text-sm text-foreground-500 w-8">{row.excel}</span>
                    </div>
                  </td>
                  <td className="py-3.5 px-5 md:px-6">
                    <div className="flex items-center gap-3">
                      <div className="flex-1 h-1.5 bg-background-200 rounded-full overflow-hidden max-w-[120px]">
                        <div
                          className="h-full bg-accent-400 rounded-full"
                          style={{ width: `${parseFloat(row.sheets) * 10}%` }}
                        ></div>
                      </div>
                      <span className="text-sm text-foreground-500 w-8">{row.sheets}</span>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(tableSchema) }}
      />
    </section>
  );
}